export default __webpack_public_path__ + "static/media/CS_145.566bd95b.png";